// Shared across every legal document on this site (Privacy Policy, Terms &
// Conditions, and any future one) so they can never drift out of sync with
// each other — real contact details as provided directly by ZenFresh.
// Distinct from src/data/legalRegistrations.ts's CIN/GSTIN/FSSAI fields,
// which stay null/empty until real government-issued registration numbers
// exist. A company name, office locality, and contact channel are not the
// same class of claim as a specific verifiable licence number.
export const COMPANY_NAME = "AVVS Software Technologies LLP";
export const REGISTERED_ADDRESS =
  "24/13, Kamala Nagar, 1st Street, Tiruvottiyur, PO: Tiruvottiyur, DIST: Tiruvallur, Tamil Nadu - 600019";
export const JURISDICTION_CITY = "Chennai";

export const CONTACT_EMAIL = "avvssoftwaretechnolgiesllp@gmail.com";
/** When the Contact page says someone is reachable. */
export const SUPPORT_HOURS = "Mon–Sat, 7am–7pm";
export const CONTACT_PHONE_DISPLAY = "+91 63669 87212";
export const CONTACT_PHONE_HREF = "+916366987212";

export const GRIEVANCE_OFFICER_NAME = "ZenFresh Operations";
